import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import $ from "jquery";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";
import Multiselect from 'react-widgets/lib/Multiselect'
import Checkbox from '@material-ui/core/Checkbox';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class ConfigEmail extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            jwt: jwt,
            user_permission: user_permission,
            miss_su: helpers.getUserType(user_type, "su"),
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            userid: user_id,
            pages: [],
            page: 0,
            rowsPerPage: 10,
            add_id: "",
            add_user: [],
            add_email_to: [],
            add_email_cc: [],
            updateIsOpen: false,
            addIsOpen: false,
            active: false
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.openView = this.openView.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.change = this.change.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);

        this.dataTable();
        this.email_user()

    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    email_user() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/service_types_user', requestOptions)
                .then(res => res.json())
                .then(data_user => {
                    var data = data_user.data;
                    console.log(data)
                    this.setState({
                        add_user: data.user,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID && this.state.src_project == '') {
                this.state.src_project = this.state.PROJECTID
            }
    
            fetch(config.url.API_URL + '/getemailconfig', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var DataFrom = data.data
                    
                    this.setState({
                        pages: [].concat(DataFrom)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getemailconfig/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataSub => {
                    var data = dataSub.data;
                    
                    this.setState({
                        add_id: data._id,
                        add_email_to: data.email_to,
                        add_email_cc: data.email_cc,
                        active: data.active_status == 1 ? true : false
                    });
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeAdd() {
        this.setState({
            addIsOpen: false
        });
    }

    submitEdit() {
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    id: this.state.add_id,
                    email_to: this.state.add_email_to,
                    email_cc: this.state.add_email_cc,
                    active_status: this.state.active ? 1 : 0,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                })
            };
    
            fetch(config.url.API_URL + '/emailconfig', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        addIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_member_name: '',
            src_member_phone: '',
            src_member_email: '',
            src_project: '',
            src_budget: '',
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Config Email List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Config Email</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    {/* <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div> */}
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '80px' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>การจัดการ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.name}</StyledTableCell>
                                                                    <StyledTableCell>{data.active_status == 1 ? "ใช้งาน" : "ไม่ใช้งาน"}</StyledTableCell>
                                                                    <StyledTableCell>{data.updateby != undefined ? data.updateby : data.createby}<br />{data.updated != undefined ? moment(data.updated).format("DD/MM/YYYY HH:mm น.") : moment(data.created).format("DD/MM/YYYY HH:mm น.")}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" />Update</button>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>แก้ไขข้อมูล</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right" >email to :</div>
                                <div className="col-sm-3">
                                    <Multiselect
                                        data={this.state.add_user}
                                        valueField='id'
                                        textField='user_name'
                                        defaultValue={this.state.add_email_to}
                                        onChange={add_email_to => this.setState({ add_email_to: add_email_to })}
                                    />
                                </div>
                                <div className="col-sm-2 text-right">email cc :</div>
                                <div className="col-sm-3">
                                    <Multiselect
                                        data={this.state.add_user}
                                        valueField='id'
                                        textField='user_name'
                                        defaultValue={this.state.add_email_cc}
                                        onChange={add_email_cc => this.setState({ add_email_cc: add_email_cc })}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ใช้งาน :</div>
                                <div className="col-sm-3">
                                    <p><Checkbox
                                        checked={this.state.active}
                                        onChange={this.handleCheck}
                                        color="primary"
                                    /></p>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}